import { Router } from '@angular/router';
var ContactReportComponent = /** @class */ (function () {
    function ContactReportComponent(router) {
        this.router = router;
    }
    ContactReportComponent.prototype.ngOnInit = function () {
        var thisTs = this;
        var table1 = $('#example1').DataTable();
        var table2 = $('#example2').DataTable();
        $('#example1 tbody').on('click', 'tr', function () {
            var data = table1.row(this).data();
            //alert('You clicked on ' + data[0] + '\'s row');
            thisTs.router.navigate(['/detail']);
        });
        $('#example2 tbody').on('click', 'tr', function () {
            var data = table2.row(this).data();
            //alert('You clicked on ' + data[0] + '\'s row');
            thisTs.router.navigate(['/detail']);
        });
    };
    ContactReportComponent.prototype.clearActionActive = function () {
        $(".action-menu").each(function () {
            $(this).removeClass("active");
        });
    };
    ContactReportComponent.prototype.CloseModal = function (modalId) {
        $("#" + modalId).modal("hide");
        this.clearActionActive();
    };
    ContactReportComponent.prototype.create = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#createModal").modal('show');
    };
    ContactReportComponent.prototype.delete = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#deleteModal").modal('show');
    };
    ContactReportComponent.prototype.forward = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#forwardModal").modal('show');
    };
    ContactReportComponent.prototype.confirmCreate = function () {
        $("#createModal").modal('hide');
    };
    ContactReportComponent.prototype.confirmForward = function () {
        $("#forwardModal").modal('hide');
    };
    ContactReportComponent.prototype.confirmDelete = function () {
        $("#deleteModal").modal('hide');
    };
    return ContactReportComponent;
}());
export { ContactReportComponent };



// WEBPACK FOOTER //
// ./src/app/contact-report/contact-report.component.ts.pre-build-optimizer.js